import { ComboBox } from "@progress/kendo-react-dropdowns";

export const FontWeightProperty = {
  propertyName: "fontWeight",
  propertyDisplay: "Font Weight",
  propertyType: "string",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <ComboBox
        name={this.propertyName}
        disabled={currentPropertyValues?.IsTab}
        data={["normal", "bold", "bolder", "lighter", "initial", "inherit"]}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        value={currentPropertyValues?.IsTab ? "" : (currentPropertyValues?.[this.propertyName] || "")}
      />
    );
  },
};
